import styled from 'styled-components';

const PrivacyLabel = styled.p`
  margin: 0;
  line-height: 18px;

  a {
    color: #9000ff;
    text-decoration: none;
  }
`;

export default PrivacyLabel;
